module.exports = __webpack_public_path__ + "img/1.7281f4a0.jpg";